export enum TelemetryEvent {
  // Translation events
  LanguageUpdated = 'UserLanguageUpdate',
  LanguageNotSupported = 'NotSupportedLocale',
  PayPalPayLaterButtonRendered = 'PayPalPayLaterButtonRendered',
  PayPalPayLaterIneligibleDisplayed = 'PayPalPayLaterIneligibleDisplayed',
  PayPalPayLaterAuthorized = 'PayPalPayLaterAuthorized',
}
